import React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

import Login from "./components/Login";

import classes from "./LoginPage.module.css";

const LoginPage = () => {
  const navigate = useNavigate();

  return (
    <div className={classes["login-page-wrapper"]}>
      <button onClick={() => navigate("/")} className={classes["back-button"]}>
        Bosh sahifaga qaytish{" "}
        <Icon icon={"material-symbols:back-to-tab-sharp"} />
      </button>
      <Login />
    </div>
  );
};

export default LoginPage;
